import React from 'react'
import socialList from './socials.json'

const SocialList = () => {
  return (
    <ul className="social">
      {socialList.map((item, index) => {
        return (
          <li key={index}>
            <a href={item.href} target="_blank" rel="noopener noreferrer">
              <i className={item.class}></i>
            </a>
          </li>
        )
      })}
    </ul>
  )
}

export default SocialList
